module.exports = __webpack_public_path__ + "static/media/logoBottom.a7beb6b7.png";